export const UP = 'up'
export const RIGHT = 'right'
export const DOWN = 'down'
export const LEFT = 'left'

export const MirrorOf = {
    [UP]: DOWN,
    [RIGHT]: LEFT,
    [DOWN]: UP,
    [LEFT]: RIGHT
}
